import { render, staticRenderFns } from "./BrandsList.vue?vue&type=template&id=3a6eb9a8&scoped=true&"
import script from "./BrandsList.vue?vue&type=script&lang=js&"
export * from "./BrandsList.vue?vue&type=script&lang=js&"
import style0 from "./BrandsList.vue?vue&type=style&index=0&id=3a6eb9a8&lang=scss&scoped=true&"
import style1 from "./BrandsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6eb9a8",
  null
  
)

export default component.exports